function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameObserverHUDTemplate = require('./game-observer-hud.template');

/**
 * HUD component for the game observer: controls, slider, status line only.
 * - Renders into this.container (set in constructor). If container not provided, uses document.body.
 * - Replaces existing #game-observer-hud if present. No sync, stability, or replay logic.
 *
 * @param {Object} app - Saito application (optional; used for makeDraggable).
 * @param {Object} observer - GameObserver instance.
 * @param {Element|string} [container=""] - DOM element to own; if falsy, document.body.
 */
var GameObserverHUD = /*#__PURE__*/function () {
  function GameObserverHUD(app, observer) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, GameObserverHUD);
    this.app = app || null;
    this.observer = observer || null;
    this.container = container || (typeof document !== 'undefined' ? document.body : null);
    this._eventsAttached = false;
  }

  /**
   * Insert or replace #game-observer-hud in this.container. Idempotent.
   */
  return _createClass(GameObserverHUD, [{
    key: "render",
    value: function render() {
      if (!this.container || typeof document === 'undefined') return;
      var html = GameObserverHUDTemplate();
      if (!html || !html.trim()) return;
      var existing = this.container.querySelector('#game-observer-hud');
      var wrap = document.createElement('div');
      wrap.innerHTML = html.trim();
      var node = wrap.firstElementChild;
      if (!node) return;
      if (existing) {
        existing.replaceWith(node);
      } else {
        this.container.appendChild(node);
      }
      this._eventsAttached = false;
      this.attachEvents();
      console.log('[HUD] render');
      if (this.container.querySelector('#game-observer-hud')) {
        console.log('[HUD] visible');
      }
    }

    /**
     * Hide the HUD with display:none in this.container.
     */
  }, {
    key: "hide",
    value: function hide() {
      if (!this.container || typeof document === 'undefined') return;
      var hud = this.container.querySelector('#game-observer-hud');
      if (hud) hud.style.display = 'none';
    }

    /**
     * Remove #game-observer-hud from this.container.
     */
  }, {
    key: "remove",
    value: function remove() {
      if (!this.container || typeof document === 'undefined') return;
      var hud = this.container.querySelector('#game-observer-hud');
      if (hud) {
        hud.remove();
        console.log('[HUD] remove');
        console.log('[HUD] removed from DOM');
      }
      this._eventsAttached = false;
      if (this.container.querySelector('#game-observer-hud')) {
        console.warn('[HUD] existence check after remove: element still in DOM');
      }
    }

    /**
     * Bind control and slider events. Call after render().
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      if (!this.container) return;
      var root = this.container.querySelector('#game-observer-hud');
      if (!root || this._eventsAttached) return;
      var observer = this.observer;
      var interactiveSelectors = ['#game-observer-state-slider', '#observer-back', '#observer-play', '#observer-forward'];
      interactiveSelectors.forEach(function (selector) {
        var el = root.querySelector(selector);
        if (!el) return;
        el.addEventListener('mousedown', function (e) {
          e.stopPropagation();
        });
        el.addEventListener('touchstart', function (e) {
          e.stopPropagation();
        });
      });
      var backBtn = root.querySelector('#observer-back');
      if (backBtn && observer) {
        backBtn.onclick = function (e) {
          var _e$target$closest;
          if ((_e$target$closest = e.target.closest('button')) !== null && _e$target$closest !== void 0 && _e$target$closest.disabled) return;
          observer.last();
        };
      }
      var playBtn = root.querySelector('#observer-play');
      if (playBtn && observer) {
        playBtn.onclick = function () {
          return observer.startPlayback();
        };
      }
      var fwdBtn = root.querySelector('#observer-forward');
      if (fwdBtn && observer) {
        fwdBtn.onclick = function (e) {
          var _e$target$closest2;
          if ((_e$target$closest2 = e.target.closest('button')) !== null && _e$target$closest2 !== void 0 && _e$target$closest2.disabled) return;
          if (fwdBtn) fwdBtn.classList.remove('flashit');
          observer.next();
        };
      }
      var slider = root.querySelector('#game-observer-state-slider');
      if (slider && observer) {
        slider.addEventListener('mousedown', function () {
          observer.playback_status = 'paused';
        });
        slider.addEventListener('touchstart', function () {
          observer.playback_status = 'paused';
        });
        slider.addEventListener('change', function () {
          var idx = parseInt(slider.value, 10);
          if (Number.isNaN(idx)) return;
          observer.replayToIndex(idx);
        });
      }
      if (this.app && this.app.browser && typeof this.app.browser.makeDraggable === 'function') {
        this.app.browser.makeDraggable('game-observer-hud');
      }
      this._eventsAttached = true;
    }
  }, {
    key: "setRange",
    value: function setRange(min, max) {
      if (!this.container) return;
      var root = this.container.querySelector('#game-observer-hud');
      if (!root) return;
      var sliderEl = root.querySelector('#game-observer-state-slider');
      if (sliderEl) sliderEl.max = String(Math.max(0, max));
      var timelineEndEl = root.querySelector('.timeline-end');
      if (timelineEndEl) timelineEndEl.textContent = String(max);
    }
  }, {
    key: "setPosition",
    value: function setPosition(pos) {
      if (!this.container) return;
      var root = this.container.querySelector('#game-observer-hud');
      if (!root) return;
      var sliderEl = root.querySelector('#game-observer-state-slider');
      if (sliderEl) {
        sliderEl.value = String(pos);
        var max = parseInt(sliderEl.max, 10) || 0;
        var progress = max > 0 ? "".concat(pos / max * 100, "%") : '0%';
        sliderEl.style.setProperty('--progress', progress);
      }
    }

    /**
     * Update status line, slider range/value, and button disabled state from observer.
     */
  }, {
    key: "updateUIState",
    value: function updateUIState() {
      var _observer$all_moves$l, _observer$all_moves, _observer$game_moves$, _observer$game_moves, _observer$_viewingInd, _observer$_paused;
      if (!this.container) return;
      var observer = this.observer;
      if (!observer) return;
      var total = (_observer$all_moves$l = (_observer$all_moves = observer.all_moves) === null || _observer$all_moves === void 0 ? void 0 : _observer$all_moves.length) !== null && _observer$all_moves$l !== void 0 ? _observer$all_moves$l : 0;
      var knownTotal = total || ((_observer$game_moves$ = (_observer$game_moves = observer.game_moves) === null || _observer$game_moves === void 0 ? void 0 : _observer$game_moves.length) !== null && _observer$game_moves$ !== void 0 ? _observer$game_moves$ : 0);
      var viewingIndex = Math.max(0, Math.min((_observer$_viewingInd = observer._viewingIndex) !== null && _observer$_viewingInd !== void 0 ? _observer$_viewingInd : 0, Math.max(0, knownTotal - 1)));
      var isPaused = (_observer$_paused = observer._paused) !== null && _observer$_paused !== void 0 ? _observer$_paused : true;
      var root = this.container.querySelector('#game-observer-hud');
      if (!root) return;
      var statusEl = root.querySelector('#observer-status-line');
      if (statusEl) {
        if (isPaused) {
          statusEl.textContent = 'Press Play to Observe';
        } else {
          statusEl.textContent = observer.shadow_status || 'Observer mode';
        }
      }
      var timelineEndEl = root.querySelector('.timeline-end');
      if (timelineEndEl) {
        timelineEndEl.textContent = String(knownTotal);
      }
      var sliderEl = root.querySelector('#game-observer-state-slider');
      if (sliderEl) {
        var max = Math.max(0, knownTotal - 1);
        sliderEl.max = String(max);
        sliderEl.value = String(viewingIndex);
        var progress = max > 0 ? "".concat(viewingIndex / max * 100, "%") : '0%';
        sliderEl.style.setProperty('--progress', progress);
      }
      var backBtn = root.querySelector('#observer-back');
      if (backBtn) backBtn.disabled = knownTotal === 0 || viewingIndex <= 0;
      var fwdBtn = root.querySelector('#observer-forward');
      if (fwdBtn) fwdBtn.disabled = knownTotal === 0 || viewingIndex >= knownTotal - 1;
      var playBtn = root.querySelector('#observer-play');
      if (playBtn) {
        playBtn.setAttribute('title', isPaused ? 'Resume' : 'Pause');
        playBtn.classList.toggle('play-state', isPaused);
        playBtn.classList.toggle('pause-state', !isPaused);
      }
    }

    /**
     * Update the status message used when playback is active (shadow_status).
     * Caller may pass HTML; it is stripped for the single status line.
     */
  }, {
    key: "updateStatus",
    value: function updateStatus(message) {
      var observer = this.observer;
      if (observer && typeof message === 'string') {
        observer.shadow_status = message.replace(/<[^>]*>/g, '').trim() || observer.shadow_status;
      }
      this.updateUIState();
    }

    /**
     * Show and enable the forward button (e.g. add flashit, refresh disabled state).
     */
  }, {
    key: "showNextMoveButton",
    value: function showNextMoveButton() {
      if (!this.container) return;
      var root = this.container.querySelector('#game-observer-hud');
      if (!root) return;
      var fwdBtn = root.querySelector('#observer-forward');
      if (fwdBtn) {
        fwdBtn.classList.add('flashit');
        this.updateUIState();
      }
    }

    /**
     * Hide emphasis and disable the forward button.
     */
  }, {
    key: "hideNextMoveButton",
    value: function hideNextMoveButton() {
      if (!this.container) return;
      var root = this.container.querySelector('#game-observer-hud');
      if (!root) return;
      var fwdBtn = root.querySelector('#observer-forward');
      if (fwdBtn) {
        fwdBtn.classList.remove('flashit');
        fwdBtn.disabled = true;
      }
    }
  }]);
}();
module.exports = GameObserverHUD;